import { useEffect, useState } from "react";
import { tourRepository } from "@/data/repositories/tourRepository";
import Tour from "@/models/Tour";

export function useTour(tourId?: string) {
  const [tour, setTour] = useState<Tour | null>(null);
  const [loading, setLoading] = useState(true);
  const [exists, setExists] = useState(false);

  useEffect(() => {
    if (!tourId) {
      setTour(null);
      setExists(false);
      setLoading(false);
      return;
    }

    setLoading(true);

    const unsubscribe = tourRepository.subscribe(
      tourId,
      t => {
        if (t) {
          setTour(t);
          setExists(true);
        } else {
          setTour(null);
          setExists(false);
        }

        setLoading(false);
      },
      () => {
        setTour(null);
        setExists(false);
        setLoading(false);
      }
    );

    return unsubscribe;
  }, [tourId]);

  return { tour, loading, exists };
}
